
const digest = '6e9326108083f3f8964e7a3f89311a493e6dd77d4cbbf897946bbff377926174';
const classes = {"wrapper":"_wrapper_18dn4_1","header":"_header_18dn4_9","compositionName":"_compositionName_18dn4_17","compositionSensitivity":"_compositionSensitivity_18dn4_28","s1":"_s1_18dn4_38","s2":"_s2_18dn4_41","s3":"_s3_18dn4_44","s4":"_s4_18dn4_48","s5":"_s5_18dn4_51"};
const css = `._wrapper_18dn4_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  border: 1px solid #eaedf3;
  margin-bottom: 12px;
  background: #fff;
}
._wrapper_18dn4_1 ._header_18dn4_9 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #000;
  margin: 0 12px;
  padding: 18px 0;
}
._wrapper_18dn4_1 ._header_18dn4_9 ._compositionName_18dn4_17 {
  font-size: 16px;
  font-weight: 500;
  gap: 15px;
  display: flex;
  align-items: center;
}
._wrapper_18dn4_1 ._header_18dn4_9 ._compositionName_18dn4_17 span {
  font-size: 12px;
  color: #ccc;
}
._wrapper_18dn4_1 ._header_18dn4_9 ._compositionSensitivity_18dn4_28 {
  font-weight: 500;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}
._wrapper_18dn4_1 ._header_18dn4_9 ._s1_18dn4_38 {
  background-color: #0cb627;
}
._wrapper_18dn4_1 ._header_18dn4_9 ._s2_18dn4_41 {
  background-color: #00BEF0;
}
._wrapper_18dn4_1 ._header_18dn4_9 ._s3_18dn4_44 {
  background-color: #0B79D9;
  color: #fff;
}
._wrapper_18dn4_1 ._header_18dn4_9 ._s4_18dn4_48 {
  background-color: #d9680b;
}
._wrapper_18dn4_1 ._header_18dn4_9 ._s5_18dn4_51 {
  background-color: #d81616;
  color: #fff;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  